import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/user.svg'
import _imports_1 from '@/assets/images/calendar-alt.svg'
import _imports_2 from '@/assets/images/social-sharing-icon/facebook-sharing-icon.svg'
import _imports_3 from '@/assets/images/social-sharing-icon/twitter-sharing-icon.svg'
import _imports_4 from '@/assets/images/social-sharing-icon/linkedin-sharing-icon.svg'
import _imports_5 from '@/assets/images/social-sharing-icon/pinterest-sharing-icon.svg'


const _hoisted_1 = { id: "mainContainer" }
const _hoisted_2 = { class: "mid-container" }
const _hoisted_3 = { class: "blog-detail-section" }
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "blog-detail-content" }
const _hoisted_6 = { class: "white__bg" }
const _hoisted_7 = { class: "blog-image-slider" }
const _hoisted_8 = { class: "blog-image-item" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "blog-auther-date" }
const _hoisted_11 = { class: "social-sharing-icons" }
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]
const _hoisted_14 = ["href"]
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "blog-content" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "next-pre-blog clearfix" }
const _hoisted_19 = { class: "previous-blog" }
const _hoisted_20 = { class: "next-blog" }
const _hoisted_21 = {
  key: 0,
  class: "blog-detail-sidebar"
}
const _hoisted_22 = { class: "related-post" }
const _hoisted_23 = { class: "related-post-list" }
const _hoisted_24 = { class: "related-post--img" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "related-post--content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_userHeader = _resolveComponent("userHeader")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_jobForm = _resolveComponent("jobForm")!
  const _component_userFooter = _resolveComponent("userFooter")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_userHeader),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["blog-detail-inner", { 'full-blog-details': _ctx.allRelatedBlogs.length == 0 }])
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: _ctx.getCdnImageAddress(_ctx.blogData.blogImage, `w_1200,h_627/`),
                      width: "100%",
                      alt: ""
                    }, null, 8, _hoisted_9)
                  ])
                ]),
                _createElementVNode("h1", null, _toDisplayString(_ctx.blogData.title), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("ul", null, [
                    _createElementVNode("li", null, [
                      _cache[2] || (_cache[2] = _createElementVNode("i", null, [
                        _createElementVNode("img", {
                          src: _imports_0,
                          alt: ""
                        })
                      ], -1)),
                      _createTextVNode(_toDisplayString(_ctx.blogData.author), 1)
                    ]),
                    _createElementVNode("li", null, [
                      _cache[3] || (_cache[3] = _createElementVNode("i", null, [
                        _createElementVNode("img", {
                          src: _imports_1,
                          alt: ""
                        })
                      ], -1)),
                      _createTextVNode(_toDisplayString(_ctx.formattedDate), 1)
                    ]),
                    _createElementVNode("li", _hoisted_11, [
                      _createElementVNode("ul", null, [
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            href: _ctx.facebookShareUrl,
                            class: "facebook",
                            target: "_blank",
                            rel: "noopener"
                          }, [...(_cache[4] || (_cache[4] = [
                            _createElementVNode("i", null, [
                              _createElementVNode("img", {
                                src: _imports_2,
                                alt: ""
                              })
                            ], -1)
                          ]))], 8, _hoisted_12)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            href: _ctx.twitterShareUrl,
                            class: "twitter",
                            target: "_blank",
                            rel: "noopener"
                          }, [...(_cache[5] || (_cache[5] = [
                            _createElementVNode("i", null, [
                              _createElementVNode("img", {
                                src: _imports_3,
                                alt: ""
                              })
                            ], -1)
                          ]))], 8, _hoisted_13)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            href: _ctx.linkedinShareUrl,
                            class: "linkedin",
                            target: "_blank",
                            rel: "noopener"
                          }, [...(_cache[6] || (_cache[6] = [
                            _createElementVNode("i", null, [
                              _createElementVNode("img", {
                                src: _imports_4,
                                alt: ""
                              })
                            ], -1)
                          ]))], 8, _hoisted_14)
                        ]),
                        _createElementVNode("li", null, [
                          _createElementVNode("a", {
                            href: _ctx.pinterestShareUrl,
                            class: "pinterest",
                            target: "_blank",
                            rel: "noopener"
                          }, [...(_cache[7] || (_cache[7] = [
                            _createElementVNode("i", null, [
                              _createElementVNode("img", {
                                src: _imports_5,
                                alt: ""
                              })
                            ], -1)
                          ]))], 8, _hoisted_15)
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("p", {
                    innerHTML: _ctx.blogData.description
                  }, null, 8, _hoisted_17)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", _hoisted_19, [
                    _createElementVNode("a", {
                      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.previousBlog && _ctx.previousBlog(...args)), ["prevent"])),
                      href: "#",
                      class: _normalizeClass({ disabled: !_ctx.hasPreviousBlog })
                    }, [...(_cache[8] || (_cache[8] = [
                      _createElementVNode("i", null, null, -1),
                      _createTextVNode(" Previous Blog ", -1)
                    ]))], 2)
                  ]),
                  _createElementVNode("li", _hoisted_20, [
                    _createElementVNode("a", {
                      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.nextBlog && _ctx.nextBlog(...args)), ["prevent"])),
                      href: "#",
                      class: _normalizeClass({ disabled: !_ctx.hasNextBlog })
                    }, [...(_cache[9] || (_cache[9] = [
                      _createTextVNode(" Next Blog ", -1),
                      _createElementVNode("i", null, null, -1)
                    ]))], 2)
                  ])
                ])
              ])
            ]),
            (_ctx.allRelatedBlogs.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _cache[10] || (_cache[10] = _createElementVNode("h3", null, "Related Posts", -1)),
                    _createElementVNode("div", _hoisted_23, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allRelatedBlogs.slice(0, 4), (relatedBlog) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "related-post-row clearfix",
                          key: relatedBlog.id
                        }, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("img", {
                              src: _ctx.getCdnImageAddress(relatedBlog.blogImage, `w_90,h_57/`),
                              alt: ""
                            }, null, 8, _hoisted_25)
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _createVNode(_component_router_link, {
                              to: `/blogs/${relatedBlog.slug}`
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(relatedBlog.title), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "clear" }, null, -1))
          ], 2)
        ])
      ])
    ]),
    _createVNode(_component_jobForm),
    _createVNode(_component_userFooter)
  ]))
}